import React, { useState, useEffect } from "react";
import "./css/Home.css";
import EventTable from "./components/EventTable";
import StartIMGSlider from "./components/StartIMGSlider";
import { Link } from "react-router-dom";

function Home() {
  var slides = [];
  if (window.innerWidth < 1024) { // mobile version
    slides = [
      { url: "img/start_slider/mobile_1.jpg", text: "Willkommen beim Ludwigsfelder Radballclub e.V." },
      { url: "img/start_slider/mobile_2.jpg", text: "Willkommen beim Ludwigsfelder Radballclub e.V." },
      { url: "img/start_slider/mobile_3.jpg", text: "Willkommen beim Ludwigsfelder Radballclub e.V." },
      { url: "img/start_slider/mobile_4.jpg", text: "Willkommen beim Ludwigsfelder Radballclub e.V." }
    ];
  } else {  // desktop version
    slides = [
      { url: "img/start_slider/desktop_1.jpg", text: "Willkommen beim Ludwigsfelder Radballclub e.V." },
      { url: "img/start_slider/desktop_2.jpg", text: "Willkommen beim Ludwigsfelder Radballclub e.V." },
      { url: "img/start_slider/desktop_3.jpg", text: "Willkommen beim Ludwigsfelder Radballclub e.V." },
    ];
  }

  // Bildwechsel-Logik für mobile Event-Bilder
  const mobileImages = [
    "img/turniere/finalfive01_2025_ludwigsfelde_mobile.png",
    "img/turniere/finalfive01_2025_ludwigsfelde_mobile_2.png"
  ];

  const [currentMobileImg, setCurrentMobileImg] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMobileImg((prev) => (prev + 1) % mobileImages.length);
    }, 8000); // alle 8 Sekunden wechseln
    return () => clearInterval(interval);
  }, [mobileImages.length]);

  return (
    <div className="page-background">
      <StartIMGSlider slides={slides} />
      <div className="page-content">
        {/* <div className="home-event-block">
          <h1>Weltmeister beim Final Five in Ludwigsfelde</h1>
          <div className="imgHolder desktopImg">
            <img src={"img/turniere/finalfive01_2025_ludwigsfelde_kombiniert.png"} alt="Final Five in Ludwigsfelde" />
          </div>
          <div className="imgHolder mobileImg">
            <img src={mobileImages[currentMobileImg]} alt="Final Five in Ludwigsfelde" />
          </div>
        </div> */}

        <div className="home-schedule">
          <h1>Heimspieltage</h1>
          <div className="tableHolder page-content-element-large">
            <EventTable maxRows={5} location={"Ludwigsfelde"} />
            <p>Weitere Events findest Du hier: <Link to="/termine">Termine</Link></p>
          </div>
        </div>

        <div className="wasIstRadball page-content-element-large">
          <Link to="/verein" style={{ textDecoration: "none", color: "inherit" }}>
            <h1 className="paddingBottom05em">Was ist Radball?</h1>
            <p className="description-text">
              Radball ist eine Sportart, die sehr viel Können und Geschick im Umgang mit ...
            </p>
          </Link>
          <div className="VideoHolder">
            <iframe
              title="home-video-wasistradball"
              src="https://player.vimeo.com/video/432439267?h=f2350597a9&color=ffffff&title=0&byline=0&portrait=0"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="radballKunstradHolder page-content-element-medium">
          <div className="imgHolder">
            <a href="https://www.radball-kunstrad.com/#home" target="_blank" rel="noopener noreferrer">
              <img src={"img/radball_kunstrad/radball-kunstrad-com.png"} alt="Radball Kunstrad IMG" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
